<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名称"></el-input>
					</el-form-item>
					
					<el-form-item label="课程名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.courseName" placeholder="请输入课程名称"></el-input>
					</el-form-item>
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.checkStatus" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="通 过" :value="1">通 过</el-option>
							<el-option key="2" label="驳 回" :value="2">驳 回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.isEnable" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="下架" :value="false">下架</el-option>
							<el-option key="1" label="上架" :value="true">上架</el-option>
						</el-select>
					</el-form-item>

					<!-- <el-form-item label="排序方式" class='tiny' cleartable>
						<el-select v-model="searchInfo.orderType" placeholder="默认修改时间降序">
							<el-option key="0" label="修改时间升序" :value="0"></el-option>
							<el-option key="3" label="创建时间降序" :value="3"></el-option>
							<el-option key="4" label="创建时间升序" :value="4"></el-option>
							<el-option key="1" label="排序等级降序" :value="1"></el-option>
							<el-option key="2" label="排序等级升序" :value="2"></el-option>
						</el-select>
					</el-form-item> -->

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="dialogVisibleFun()">新增课程
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="courseList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
		 element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="用户ID">
							<span>{{ props.row.userId?props.row.userId:'无' }}</span>
						</el-form-item>
						<el-form-item label="用户名">
							<span>{{ props.row.username?props.row.username:'无' }}</span>
						</el-form-item>
						<el-form-item label="供应商ID">
							<span>{{ props.row.storeId }}</span>
						</el-form-item>
					
						<el-form-item label="课程ID">
							<span>{{ props.row.id }}</span>
						</el-form-item>
						<el-form-item label="课程名称">
							<span>{{ props.row.courseName }}</span>
						</el-form-item>
						<el-form-item label="课程浏览量">
							<span>{{ props.row.browseCnt }}</span>
						</el-form-item>
						<el-form-item label="课程评论量">
							<span>{{ props.row.commentCnt }}</span>
						</el-form-item>

						<el-form-item label="课程收藏量">
							<span>{{ props.row.favoriteCnt }}</span>
						</el-form-item>
						<el-form-item label="课程点赞量">
							<span>{{ props.row.praiseCnt }}</span>
						</el-form-item>
						<el-form-item label="uv浏览量">
							<span>{{ props.row.uvCnt }}</span>
						</el-form-item>
						<el-form-item label="pv浏览量">
							<span>{{ props.row.pvCnt }}</span>
						</el-form-item>

						<!-- <el-form-item v-if="props.row.authStatus == 2" label="驳回原因">
							<span>{{ props.row.rejected }}</span>
						</el-form-item> -->
						<el-form-item label="课程详细描述">
							<el-button size="small" type="text" @click="findDetail(props.row.courseDetails,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="课程封面图">
							<el-button size="small" type="text" @click="findDetail(props.row.courseImg,2)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>

			<el-table-column prop="id" label="课程ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="username" label="用户名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="authorName" label="作者名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isEnable" label="课程状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="!scope.row.isEnable">下架</p>
					<p v-if="scope.row.isEnable">上架</p>
				</template>
			</el-table-column>
			<el-table-column prop="courseName" label="课程名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="typeName" label="所属类别" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="isFee" label="费用" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isFee">付费</p>
					<p v-if="!scope.row.isFee">免费</p>
				</template>
			</el-table-column>

			<el-table-column prop="marketPrice" label="市场价" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="coursePrice" label="现价" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="checkStatus" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.checkStatus==0">待审核</p>
					<p v-if="scope.row.checkStatus==1">通 过</p>
					<p v-if="scope.row.checkStatus==2">驳 回</p>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button v-if="scope.row.checkStatus==1" size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑
					</el-button>
					<el-button v-if="scope.row.checkStatus==0" size="small" type="text" @click="editCourseInfoCheck(scope.row.id,1)">
						通过</el-button>
					<el-button v-if="scope.row.checkStatus==0" size="small" type="text" @click="editialogVisible(scope.row.id)">驳回
					</el-button>
					<!-- <div v-if="scope.row.authStatus==2">不可操作</div> -->
					　　　　　　
					<el-dropdown v-if="scope.row.checkStatus==1" trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="courseIsEnable(scope.row.id)" v-if="!scope.row.isEnable && scope.row.checkStatus==1">上架</el-dropdown-item>
							<el-dropdown-item @click.native="courseIsEnable(scope.row.id)" v-if="scope.row.isEnable && scope.row.checkStatus==1">下架</el-dropdown-item>
							<el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					　　　　
				</template>
				　　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="courseList.pageNum" @current-change="pageChange"
		 layout="total, sizes, prev, pager, next, jumper" :total="courseList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 审核驳回 -->
		<el-dialog style="float:rigin" title="审核驳回" :visible.sync="editDialogVisible" width="35%">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" size="medium">
					<el-form-item label="驳回原因:">
						<el-col :span="18">
							<el-input v-model="form.refuseReason" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
					<el-form-item style="text-align: center;">
						<el-button type="primary" @click="editCourseInfoCheck(courseId,2)" :loading="checkLoading">确 定</el-button>
						<el-button @click="cannelPass">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails" 
		width="50%" >
		
			<div style="max-height:700px;overflow-y:scroll; overflow-x:hidden;">
				<div class="detailImg" v-if="detailType == 1" v-html="detail" ></div>
				<div v-if="detailType == 2" style="">
					<img style="width:100%;padding: 20px 0px ;" :src="image" v-for="(image,index) in  images" :key="index" />
				</div>
			</div>
			
			<!-- <div v-if="detailType == 2"
				style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
				<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
			</div> -->
			
			<div style="text-align: center;margin-top:30px">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 课程编辑 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false" :visible.sync="dialogVisible"
		 width="75%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="padding: 10px;margin-bottom: 20px;" v-show="dialogVisibleFunName == '新增课程'">
						<!-- <div style="text-align: left;">
							请选择供应商：
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item :label-width="formLabelWidth" label="用户名">
								<el-input type="text" clearable v-model="courseInfo.username" placeholder="请输入用户名(搜索条件)" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="作者名称">
								<el-input type="text" clearable v-model="courseInfo.authorName" placeholder="请输入供应商名称(搜索条件)" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="搜索按钮">
								<el-button type="primary" @click="searchStore">搜 索</el-button>
							</el-form-item>
						</div> -->

						<div style="display: flex;align-items: center;justify-content: space-between;">

							<el-form-item :label-width="formLabelWidth" label="选择作者">
								<el-select v-model="courseInfo.storeId" class="big" placeholder="请选择" @change="getStoreAndUser">
									<el-option v-for="item in accountList" :key="item.id" :value="item.id" :label="item.authorName">
									</el-option>
								</el-select>
							</el-form-item>

						</div>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth" label="作者名称" v-show="dialogVisibleFunName != '新增课程'">
							<el-input type="text" v-model="courseInfo.authorName" placeholder="请输入" disabled />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="课程名称" style="width: 50%;">
							<el-input type="text" clearable v-model="courseInfo.courseName" placeholder="请输入" />
						</el-form-item>
						<!-- <el-form-item :label-width="formLabelWidth" label="讲师名称" style="width: 40%;">
							<el-input type="text" clearable v-model="courseInfo.lecturerName" placeholder="请输入" />
						</el-form-item> -->
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth" label="课程分类">
							<el-col :span="13.5">
								<el-select clearable v-model="courseClassify1Id" placeholder="请选择一级分类" style="width:200px;margin-right:10px;"
								 @change="courseClassify1">
									<el-option clearable v-for="item in courseClassify1List" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
								</el-select>
								<el-select clearable v-model="courseClassify2Id" placeholder="请选择二级分类" style="width:200px;margin:  0px 10px;"
								 @change="courseClassify2">
									<el-option v-for="item in courseClassify2List" :key="item.id" :label="item.typeName" :value="item.id">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>

						<el-form-item :label-width="'140px'" label="课程封面(750*420)">
							<el-upload class="avatar-uploader" :action="fileUploadHttpUrl" :show-file-list="false" :on-success="onSuccess"
							 :on-preview="handlePictureCardPreview" >
								<img v-if="courseInfo.courseImg" :src="courseInfo.courseImg" style="width: 100%;">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth" label="是否付费" class="redItem">
							<el-switch v-model="courseInfo.isFee" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="市场价" class="redItem" v-show="courseInfo.isFee">
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50" v-model="courseInfo.marketPrice"
							 placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="课程价格" class="redItem" v-show="courseInfo.isFee">
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50" v-model="courseInfo.coursePrice"
							 placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="销量" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50" v-model="courseInfo.sales"
							 placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="是否上架" class="redItem">
							<el-switch v-model="courseInfo.isEnable" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
						<!-- <el-form-item :label-width="formLabelWidth" label="是否系列" class="redItem">
							<el-switch v-model="courseInfo.isSeries" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item> -->
					</div>

					<div>
						<el-form-item :label-width="formLabelWidth" label="课程简介"><br />
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="courseInfo.courseInto">
							</el-input>
						</el-form-item>
					</div>

					<div>
						<div style="text-align: start;margin: 10px;">课程详情</div>
						<el-form-item >
							<div id="lpc-quill" class="quill" style="width: 100%;">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl" :before-upload="beforeAvatarUpload"
								 :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="courseInfo.courseDetails" ref="myQuillEditor" class="editer" :options="editorOption"
								style="height:600px"
								 @ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>

					<div style="margin-top:80px">
						<div style="text-align: start;margin: 10px;">
							<el-button type="primary" icon="el-icon-circle-plus-outline" @click="courseProductList.push({
								isFee: false,
								title: '',
								img: '',
								intro: '',
								courseFileUrl:'',
								courseFileName: '',
								courseFileType:'',
								courseFileSize:'',
								courseFileSuffix:'',
								videoDuration:''
							})">添加课程文件</el-button>
						</div>
						<div :style="'padding: 10px;margin-bottom: 20px;'+ (item.id?'border: 1px solid #000000;':'border: 1px solid red;')"
						 v-for="(item,index) in courseProductList" :key="index">
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item :label-width="formLabelWidth" label="标题" style="width: 40%;">
									<el-input type="text" clearable v-model="item.title" placeholder="请输入" />
								</el-form-item>
								<el-form-item :label-width="'140px'" label="课程封面(750*420)">
									<el-upload class="avatar-uploader" :action="fileUploadHttpUrl" :show-file-list="false" :on-success="onImgSuccess"
									 :on-preview="handlePictureCardPreview" >
										<img v-if="item.img" :src="item.img" style="width: 100%;" @click="courseProductListIndex = index">
										<i v-else class="el-icon-plus avatar-uploader-icon" @click="courseProductListIndex = index"></i>
									</el-upload>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="课程文件">
									<div style="display: block;">
										<el-upload class="upload-demo" :ref="'upload'+index" :action="fileUploadHttpUrl" :on-success="onFileSuccess"
										 :file-list="fileList[index]" :on-remove="handleRemove">
											<el-button size="small" type="primary" @click="courseProductListIndex = index">点击上传</el-button>
										</el-upload>
									</div>
									<div style="display: block;">
										<el-button type="text" style="margin-left: 10px;" icon="el-icon-zoom-in" v-show="item.courseFileUrl" @click="browseFile(item.courseFileUrl)">查看文件</el-button>
									</div>
								</el-form-item>
							</div>

							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item v-show="courseInfo.isFee" :label-width="formLabelWidth" label="是否付费" class="redItem">
									<el-switch v-model="item.isFee" :active-value="true" :inactive-value="false">
									</el-switch>
								</el-form-item>

								<el-form-item v-show="item.courseFileName" :label-width="formLabelWidth" label="文件名称" class="redItem">
									<div>{{item.courseFileName}}</div>
								</el-form-item>
								<el-form-item v-show="item.courseFileType >= 0 && item.courseFileUrl" :label-width="formLabelWidth" label="文件类型">
									<div v-show="item.courseFileType == 0">文档</div>
									<div v-show="item.courseFileType == 1">图片</div>
									<div v-show="item.courseFileType == 2">视频</div>
								</el-form-item>
								<el-form-item v-show="item.courseFileType == 2 && item.videoDuration" :label-width="formLabelWidth" label="视频时长">
									<div>{{item.videoDuration}}</div>
								</el-form-item>
								<el-form-item v-show="item.courseFileSuffix" :label-width="formLabelWidth" label="文件后缀" class="redItem">
									<div>{{item.courseFileSuffix}}</div>
								</el-form-item>
								<el-form-item v-show="item.courseFileSize" :label-width="formLabelWidth" label="文件大小">
									<div>{{item.courseFileSize}} KB</div>
								</el-form-item>
							</div>

							<div>
								<el-form-item :label-width="formLabelWidth" label="课程简介"><br />
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="item.intro">
									</el-input>
								</el-form-item>
							</div>

							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-button @click="deleteCourseFile(item,index)">删 除</el-button>
								<el-button @click="save(item,index)" type="primary" v-show="dialogVisibleFunName == '编辑课程'">保存</el-button>
							</div>

						</div>
					</div>

				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button v-show="dialogVisibleFunName == '新增课程'" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				<el-button v-show="dialogVisibleFunName == '编辑课程'" type="primary" @click="sure" :loading="sureLoading">编 辑</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		uploadFile,
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFile('course');
	var fileUploadHttpUrl = uploadFileServer('course');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};

	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				formLabelWidth: '100px',
				setUpBuyVisible: false,
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				fileUploadHttpUrl: fileUploadHttpUrl,
				loading: false,
				courseList: [{}], //列表
				courseProductList: [{}],
				courseProductListIndex: 0,
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],

				fileList: [],

				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,

				courseClassify1List: [],
				courseClassify2List: [],
				classGoods3List: [],
				courseClassify1Id: "",
				courseClassify2Id: "",

				courseInfo: {
					classId: "",
					isFee: false
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				courseId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					checkStatus: '',
					isEnable: '',
				},
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},

				checkLoading: false,

				addLoading: false,
				sureLoading: false,
			};
		},

		methods: {
			deleteCourseFile(item, index) {
				if (item.id) {
					this.$api.deleteCourseFile(item.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.courseProductList.remove(item);
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					this.courseProductList.remove(item);
				}
			},
			save(item, index) {
				if (item.id) {
					this.$api.editBcCourseProduct(item).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.courseProductList[index] = res.data;
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					item.courseId = this.courseInfo.id;
					item.userId = this.courseInfo.userId;
					this.$api.addBcCourseProduct(item).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							if (res.data) {
								this.courseProductList[index].id = res.data.id;
							} else {

							}
						} else {
							this.$message.error(res.message);
						}
					})
				}
			},
			browseFile(url) {
				var featrues =
					"height=500, width=800, top=100, left=100, toolbar=no, menubar=no,scrollbars=no,resizable=no, location=no, status=no"; //设置新窗口的特性
				window.open(url, "newW", featrues); //打开新窗口
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
				this.courseProductList[this.courseProductListIndex].courseFileUrl = '';
				this.courseProductList[this.courseProductListIndex].courseFileName = '';
				this.courseProductList[this.courseProductListIndex].courseFileType = '';
				this.courseProductList[this.courseProductListIndex].courseFileSize = '';
				this.courseProductList[this.courseProductListIndex].courseFileSuffix = '';
				this.courseProductList[this.courseProductListIndex].videoDuration = '';
			},
			onFileSuccess(response, file, fileList) {
				if (response && response.state == 'success') {
					console.log(this.courseProductListIndex)
					console.log(response)
					// var courseProduct = {
					// 	isFee: this.courseProductList[this.courseProductListIndex].isFee,
					// 	title: this.courseProductList[this.courseProductListIndex].title,
					// 	img: this.courseProductList[this.courseProductListIndex].img,
					// 	intro: this.courseProductList[this.courseProductListIndex].intro,
					// 	courseFileUrl:response.data.url,
					// 	courseFileName: response.data.fileName,
					// 	courseFileType:response.data.fileType,
					// 	courseFileSize:response.data.fileSize,
					// 	courseFileSuffix:response.data.fileSuffix,
					// 	videoDuration:response.data.videoDuration
					// }

					// this.courseProductList[this.courseProductListIndex] = courseProduct;

					this.courseProductList[this.courseProductListIndex].courseFileUrl = response.data.url;
					this.courseProductList[this.courseProductListIndex].courseFileName = response.data.fileName;
					this.courseProductList[this.courseProductListIndex].courseFileType = response.data.fileType;
					this.courseProductList[this.courseProductListIndex].courseFileSize = response.data.fileSize;
					this.courseProductList[this.courseProductListIndex].courseFileSuffix = response.data.fileSuffix;
					this.courseProductList[this.courseProductListIndex].videoDuration = response.data.videoDuration;
					var indexRefs = 'upload' + this.courseProductListIndex
					this.$refs[indexRefs][0].clearFiles();
					this.fileList[this.courseProductListIndex] = [];
					this.fileList[this.courseProductListIndex].push({
						name: response.data.fileName,
						url: response.data.url
					})
				} else {
					console.log(response)
					var indexRefs = 'upload' + this.courseProductListIndex
					this.$refs[indexRefs][0].clearFiles();
					this.fileList[this.courseProductListIndex] = [];
					this.courseProductList[this.courseProductListIndex].courseFileUrl = '';
					this.courseProductList[this.courseProductListIndex].courseFileName = '';
					this.courseProductList[this.courseProductListIndex].courseFileType = '';
					this.courseProductList[this.courseProductListIndex].courseFileSize = '';
					this.courseProductList[this.courseProductListIndex].courseFileSuffix = '';
					this.courseProductList[this.courseProductListIndex].videoDuration = '';
					if (response) {
						this.$message.error(response.message);
					}
				}
			},
			onImgSuccess(response, file, fileList) {
				if (response && response.state == 'success') {
					this.courseProductList[this.courseProductListIndex].img = response.data.url;
				} else {
					console.log(response)
					if (response) {
						this.$message.error(response.message);
					}
				}
			},
			onSuccess(response, file, fileList) {
				
				if (response && response.state == 'success') {
					
					var courseInfo = {
						username: this.courseInfo.username,
						authorName: this.courseInfo.authorName,
						storeId: this.courseInfo.storeId,
						courseName: this.courseInfo.courseName,
						lecturerName: this.courseInfo.lecturerName,
						classifyId: this.courseInfo.classifyId,
						marketPrice: this.courseInfo.marketPrice,
						coursePrice: this.courseInfo.coursePrice,
						sales: this.courseInfo.sales,
						isEnable: this.courseInfo.isEnable,
						isFee: this.courseInfo.isFee,
						courseImg: response.data.url,
						courseInto: this.courseInfo.courseInto,
						courseDetails: this.courseInfo.courseDetails
					}
					this.courseInfo = courseInfo;
					console.log(this.courseInfo.courseImg)
				} else {
					console.log(response)
					if (response) {
						this.$message.error(response.message);
					}
				}
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			getStoreAndUser(e) {
				console.log(e);
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.courseInfo.username = obj.username;
				this.courseInfo.authorName = obj.authorName;
				this.courseInfo.userId = obj.userId;
			},
			searchStore() {
				
				this.$api.findAllauthor().then((res) => {
					console.log(res);
					if (res.state == 'success') {
						this.courseInfo.storeId = res.data[0].id
						this.accountList = res.data;
						console.log(this.accountList);
					} else {
						this.$message.error(res.message);
					}
				})
			},
			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			courseIsEnable(id) {
				this.$api.courseIsEnable(id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.findCourseList()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.findCourseList()
			},
			//课程审核
			editCourseInfoCheck(id, checkStatus) {
				this.checkLoading = true;
				if (checkStatus == 2) {
					//驳回
					var data = {
						id: this.courseId,
						checkStatus: checkStatus,
						rejected: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						checkStatus: checkStatus
					}
				}
				this.$api.checkCourse(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.findCourseList()
					} else {
						this.$message.error(res.message);
					}
					this.checkLoading = false;
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			//审核驳回弹窗打开
			editialogVisible(id) {
				this.form.refuseReason = ""
				this.courseId = id
				this.editDialogVisible = true;
			},
			//选中一级分类
			courseClassify1(e) {
				this.courseClassify2Id = "";
				if (e) {
					console.log(e)
					this.$api.findBcClassifyListByPid(e).then((res) => { //课程二级分类
						if (res.state == 'success') {
							this.courseClassify2List = res.data.list;
						}
					})
				}
			},
			//选中二级分类
			courseClassify2(e) {
				console.log(e)
				let obj = {};
				obj = this.courseClassify2List.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.courseInfo.typeName = obj.typeName;
				this.courseInfo.classifyId = obj.id;
			},
			// 作者编辑弹窗
			dialogVisibleFun(id) {
				this.dialogVisibleFunName = "新增课程"
				this.dialogVisible = true;

				this.courseInfo = {
					isFee: false,
					storeId: '',
					authorName: '',
					username: ''
				};
				this.courseClassify2List = [];
				this.courseClassify1Id = "";
				this.courseClassify2Id = "";

				this.courseProductList = [{
					isFee: false,
					title: '',
					img: '',
					intro: '',
					courseFileUrl: '',
					courseFileName: '',
					courseFileType: '',
					courseFileSize: '',
					courseFileSuffix: '',
					videoDuration: ''
				}];

				if (id) {
					this.dialogVisibleFunName = "编辑课程"
					this.courseId = id
					this.$api.findBcCourseById(this.courseId).then((res) => {
						if (res.state == 'success') {
							this.courseInfo = res.data
							this.searchStore();
							this.courseClassify2Id = this.courseInfo.classifyId

							this.$api.findBcClassifyById(this.courseClassify2Id).then((res) => {
								if (res.state == 'success') {
									this.courseClassify1Id = res.data.pid;
									this.$api.findBcClassifyListByPid(res.data.pid).then((res) => { //课程一级分类
										if (res.state == 'success') {
											this.courseClassify2List = res.data.list;
										}
									})
								}
							})

							this.$api.findBcCourseProductListByCourseId(this.courseId).then((res) => {
								if (res.state == 'success') {
									this.courseProductList = res.data.list;
									this.fileList = [];
									for (let i = 0; i < this.courseProductList.length; i++) {
										this.fileList.push([{
											name: this.courseProductList[i].courseFileUrl,
											name: this.courseProductList[i].courseFileName
										}])
									}
								}
							})
						}
					})
				}
			},
			//添加课程
			add() {
				
				if (!this.courseProductList || this.courseProductList.length == 0) {
					this.$message.error('请上传课程文件');
					return;
				} else {
					this.courseInfo.courseProductList = this.courseProductList;
				}
				if (!this.courseInfo.isFee) {
					this.courseInfo.marketPrice = 0.00;
					this.courseInfo.coursePrice = 0.00;
				}

				this.addLoading = true;
				this.$api.addBcCourse(this.courseInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.findCourseList();
					} else {
						this.$message.error(res.message);
					}
					this.addLoading = false;
				})
			},
			//编辑商品
			sure() {
				if (!this.courseInfo.isFee) {
					this.courseInfo.marketPrice = 0.00;
					this.courseInfo.coursePrice = 0.00;
				}
				this.sureLoading = true;
				this.$api.editBcCourse(this.courseInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.findCourseList();
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false;
				})

			},
			//删除
			toDelete(row) {
				/* if (row.status == 0) {
					var str = "此操作将启用该作者账号, 是否继续?"
				} else {
					var str = "此操作将禁用该作者账号, 是否继续?"
				} */
				var str = "此操作将删除该课程, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delBcCourseById(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findCourseList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.findCourseList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findCourseList()
			},
			findCourseList() {
				this.loading = true
				this.searchInfo.pageNum = this.page.pageNum;
				this.searchInfo.pageSize = this.page.pageSize;

				this.$api.getCourseList(this.searchInfo).then((res) => { //商品列表
					if (res.state == 'success') {
						this.courseList = res.data
						this.loading = false
					}
				})
			},

			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			//上传作者logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					console.log('列表:', res);
					this.storeInfo.storeLogo = res.message
				})
			},
			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					console.log('列表:', res);
					this.storeInfo.legalIdFace = res.message
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					console.log('列表:', res);
					this.storeInfo.legalIdBack = res.message
				})
			},

			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.data !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				console.log(editor);
			}
		},
		created() {
			this.findCourseList();
			this.searchStore()
			this.$api.findBcClassifyListByPid(0).then((res) => { //课程一级分类
				if (res.state == 'success') {
					this.courseClassify1List = res.data.list;
				}
			})

		}

	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 105px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}
</style>
